let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lxzGu")).then(() => parcelRequire('jp5Rx'));